import React, { useRef } from 'react';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { DialogActions, DialogContent, DialogTitle } from '../dialogs';
import { Dialog } from './dialog';
import { IZone } from '../../models';
import { theme } from '../../configs';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ZoneFeedbackForm } from '../../forms/zones/zone-feedback/zone-feeback.form';

interface FeedbackDialogProps {
  zone: IZone;
  visible?: boolean;
  setVisible?: (value: boolean) => void;
  onSuccess?: () => void;
}
export const FeedbackDialog = (props: FeedbackDialogProps) => {
  const { zone, visible = false, setVisible = () => {}, onSuccess = () => {} } = props;
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));
  const formRef = useRef<any>();

  const onClose = () => {
    setVisible(false);
  };

  const handleFeedbackFormSubmitted = () => {
    onSuccess();
    setVisible(false);
  };

  const onSubmit = () => {
    formRef.current.onSubmit();
  };

  return (
    <Dialog open={visible} onClose={onClose} fullScreen={down_sm}>
      <DialogTitle sx={{ textAlign: 'center' }}>
        <Typography color="primary" style={{ fontWeight: 'bold', fontSize: 18 }}>
          Request A Service
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant={'subtitle2'}>Does something need attention?</Typography>
          <Typography variant={'subtitle2'}>Let us know how we can help.</Typography>
        </Box>
        <ZoneFeedbackForm ref={formRef} zone={zone} next={handleFeedbackFormSubmitted} />
      </DialogContent>
      <DialogActions sx={{ flexDirection: 'column' }}>
        <Button variant="contained" onClick={onSubmit}>
          Send Request
        </Button>
        <Button startIcon={<ArrowBackIcon />} color="primary" sx={{ marginTop: 1 }} onClick={() => setVisible(false)}>
          Go Back
        </Button>
      </DialogActions>
    </Dialog>
  );
};
